export default function ODAplicationIcon(){
    return(
        <>
        <svg
                      xmlns="http://www.w3.org/2000/svg"
                      version="1.1"
                      xmlnsXlink="http://www.w3.org/1999/xlink"
                      width={18}
                      height={18}
                      x={0}
                      y={0}
                      viewBox="0 0 64 64"
                      style={{ enableBackground: "new 0 0 512 512" }}
                      xmlSpace="preserve"
                      className=""
                    >
                      <g>
                        <path
                          d="M56.716 44.31c0-.513-.098-1.016-.289-1.485a3.974 3.974 0 0 0-4.675-2.393c-.045.012-.09.026-.133.044L38.376 45.93c-.015-.106-.02-.213-.047-.318a3.148 3.148 0 0 0-3.445-2.366c-.045.006-.09.015-.134.026l-13.84 3.706-4.929-.824V43a1 1 0 0 0-1-1H10a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h4.981a1 1 0 0 0 1-1v-2h6.788l6.175 2.325c.556.21 1.14.315 1.729.315.786 0 1.579-.188 2.325-.568l21.51-13.177a3.974 3.974 0 0 0 2.208-3.585zM13.981 60H11V44h2.981zM53.54 46.147 32.022 59.328c-.734.372-1.6.417-2.373.126l-6.346-2.39a.988.988 0 0 0-.352-.064h-6.97v-8.819l4.812.805c.14.023.286.017.424-.021l13.975-3.742a1.153 1.153 0 0 1 1.058 1.763c-.165.267-.423.45-.727.519a.986.986 0 0 0-.128.038l-6.813 2.52.693 1.875 6.756-2.498a3.099 3.099 0 0 0 1.666-1.067l14.612-6.018c.94-.205 1.901.3 2.26 1.211.097.24.146.49.146.744.001.77-.42 1.458-1.175 1.837zM32 26c-.551 0-1-.448-1-1h-2c0 1.302.839 2.402 2 2.816V29h2v-1.184A2.996 2.996 0 0 0 35 25c0-1.654-1.346-3-3-3a1.001 1.001 0 0 1 0-2c.551 0 1 .448 1 1h2a2.996 2.996 0 0 0-2-2.816V17h-2v1.184A2.996 2.996 0 0 0 29 21c0 1.654 1.346 3 3 3a1.001 1.001 0 0 1 0 2z"
                          fill="#000000"
                          opacity={1}
                          data-original="#000000"
                          className=""
                        />
                        <path
                          d="M19 13a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h26a1 1 0 0 0 1-1V14a1 1 0 0 0-1-1zm25 18H20V15h24z"
                          fill="#000000"
                          opacity={1}
                          data-original="#000000"
                          className=""
                        />
                        <path
                          d="M8.006 34.891c-.042.389.145.766.479.967l5 3a1.007 1.007 0 0 0 .92.056 1 1 0 0 0 .576-.718l1-5a.998.998 0 0 0-1.297-1.144l-2.193.731A20.825 20.825 0 0 1 11 25c0-11.579 9.42-21 21-21s21 9.421 21 21c0 4.501-1.403 8.792-4.056 12.408l1.612 1.184A22.824 22.824 0 0 0 55 25C55 12.317 44.682 2 32 2S9 12.317 9 25c0 2.916.535 5.741 1.589 8.417l-1.906.635a.998.998 0 0 0-.677.839zm5.676-.398-.384 1.919-1.919-1.151z"
                          fill="#000000"
                          opacity={1}
                          data-original="#000000"
                          className=""
                        />
                      </g>
                    </svg>
        </>
    )
}
